module.exports = __webpack_public_path__ + "static/3-daily_toast-8bc16c35a11c39f0fe9456a512806fb5.png";